/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetFloorplans200ResponseValueTablesInner
 */
export interface GetFloorplans200ResponseValueTablesInner {
    /**
     * 
     * @type {string}
     * @memberof GetFloorplans200ResponseValueTablesInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetFloorplans200ResponseValueTablesInner
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof GetFloorplans200ResponseValueTablesInner
     */
    x: number;
    /**
     * 
     * @type {number}
     * @memberof GetFloorplans200ResponseValueTablesInner
     */
    y: number;
    /**
     * 
     * @type {number}
     * @memberof GetFloorplans200ResponseValueTablesInner
     */
    width: number;
    /**
     * 
     * @type {number}
     * @memberof GetFloorplans200ResponseValueTablesInner
     */
    height: number;
    /**
     * 
     * @type {string}
     * @memberof GetFloorplans200ResponseValueTablesInner
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof GetFloorplans200ResponseValueTablesInner
     */
    min: number;
    /**
     * 
     * @type {number}
     * @memberof GetFloorplans200ResponseValueTablesInner
     */
    max: number;
    /**
     * 
     * @type {string}
     * @memberof GetFloorplans200ResponseValueTablesInner
     */
    zone: string;
    /**
     * 
     * @type {string}
     * @memberof GetFloorplans200ResponseValueTablesInner
     */
    floorplanId: string;
    /**
     * 
     * @type {number}
     * @memberof GetFloorplans200ResponseValueTablesInner
     */
    terraceSurchargePercentage: number;
    /**
     * 
     * @type {number}
     * @memberof GetFloorplans200ResponseValueTablesInner
     */
    flatFeeSurcharge?: number;
    /**
     * 
     * @type {string}
     * @memberof GetFloorplans200ResponseValueTablesInner
     */
    surchargeType?: string | null;
}

/**
 * Check if a given object implements the GetFloorplans200ResponseValueTablesInner interface.
 */
export function instanceOfGetFloorplans200ResponseValueTablesInner(value: object): value is GetFloorplans200ResponseValueTablesInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('x' in value) || value['x'] === undefined) return false;
    if (!('y' in value) || value['y'] === undefined) return false;
    if (!('width' in value) || value['width'] === undefined) return false;
    if (!('height' in value) || value['height'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('min' in value) || value['min'] === undefined) return false;
    if (!('max' in value) || value['max'] === undefined) return false;
    if (!('zone' in value) || value['zone'] === undefined) return false;
    if (!('floorplanId' in value) || value['floorplanId'] === undefined) return false;
    if (!('terraceSurchargePercentage' in value) || value['terraceSurchargePercentage'] === undefined) return false;
    return true;
}

export function GetFloorplans200ResponseValueTablesInnerFromJSON(json: any): GetFloorplans200ResponseValueTablesInner {
    return GetFloorplans200ResponseValueTablesInnerFromJSONTyped(json, false);
}

export function GetFloorplans200ResponseValueTablesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFloorplans200ResponseValueTablesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'x': json['x'],
        'y': json['y'],
        'width': json['width'],
        'height': json['height'],
        'type': json['type'],
        'min': json['min'],
        'max': json['max'],
        'zone': json['zone'],
        'floorplanId': json['floorplanId'],
        'terraceSurchargePercentage': json['terraceSurchargePercentage'],
        'flatFeeSurcharge': json['flatFeeSurcharge'] == null ? undefined : json['flatFeeSurcharge'],
        'surchargeType': json['surchargeType'] == null ? undefined : json['surchargeType'],
    };
}

export function GetFloorplans200ResponseValueTablesInnerToJSON(json: any): GetFloorplans200ResponseValueTablesInner {
    return GetFloorplans200ResponseValueTablesInnerToJSONTyped(json, false);
}

export function GetFloorplans200ResponseValueTablesInnerToJSONTyped(value?: GetFloorplans200ResponseValueTablesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'x': value['x'],
        'y': value['y'],
        'width': value['width'],
        'height': value['height'],
        'type': value['type'],
        'min': value['min'],
        'max': value['max'],
        'zone': value['zone'],
        'floorplanId': value['floorplanId'],
        'terraceSurchargePercentage': value['terraceSurchargePercentage'],
        'flatFeeSurcharge': value['flatFeeSurcharge'],
        'surchargeType': value['surchargeType'],
    };
}

